import { render, staticRenderFns } from "./qrcodeVersionController.vue?vue&type=template&id=201f7b27&"
import script from "./qrcodeVersionController.vue?vue&type=script&lang=ts&"
export * from "./qrcodeVersionController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports